/**
 * Migrated from https://github.com/themaven-net/tempest-phoenix/blob/1cb7d4f8321f84b1aa89a2ee8626cd2ffeb6311e/server/lib/util.js#L710
 */
export const isIndividualContributorContent = (siteConfig, item) => !!(!siteConfig?.isHubpagesSite &&
    (item.isReadonlyContent ?? false) &&
    Array.isArray(item.externalReferences) &&
    item.externalReferences.find((e) => e.source === 'hubpages'));
//# sourceMappingURL=util.js.map